import { TrackPageActionApplyT } from '@consumer-frontend/nc-utils';

import { useBeaconTracking } from './useBeaconTracking';
import { apiEndpoints } from '../../lib';

const endpoints = {
  trackPageUrl: apiEndpoints.apply.v2.trackPage,
};

/**
 * Provides Apply app page view tracking via the Beacon API.
 *
 * @returns Page tracking trigger
 */
export const useTrackingApply = () => {
  return useBeaconTracking<TrackPageActionApplyT>({
    endpoints,
  });
};
